import { render, staticRenderFns } from "./StatisticWidgetTotal.vue?vue&type=template&id=30bd9792&"
import script from "./StatisticWidgetTotal.vue?vue&type=script&lang=js&"
export * from "./StatisticWidgetTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports